// First, before App's imports make any schema: Zod must not try eval under the pages' policy.
import "./lib/zod";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
// The suite's stylesheet, Inter with it, served from Link's own host: the pages load nothing from anywhere else (public/_headers).
import "./styles/globals.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
